var exports = {
  "k": "x31de4314--89982f--container",
};

module.exports = exports;
